import {RouteStatusStatusType} from "@Route/types/status/RouteStatusStatus.type";

export default function routeIsClosedOrUnavailable(status: RouteStatusStatusType) {
    return status === "closed" || status === "unavailable"
}